import styled from "styled-components";
import { IoArrowBack } from "react-icons/io5";
import { useAdmin } from "../../../context/admin";

export default function Create() {
    const { setIsCreateSubzoneModalOpen, subzonesZone, setSubzonesZone } = useAdmin()
    return (
        <Main>
            <div className="left">
                <button className="back" type="button"
                onClick={() => setSubzonesZone(undefined)}
                >
                    <IoArrowBack/> Zonas
                </button>
                <h2>Subzonas de <strong>{subzonesZone}</strong></h2>
            </div>
            <div className="buttons">
                <button className="tour" type="button"
                onClick={() => setIsCreateSubzoneModalOpen(true)}
                >
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"></path><path fill="currentColor" d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z"></path></svg>
                        Create Subzone
                    </span>
                </button>
            </div>
        </Main>
    )
}

const Main = styled.section`
width: 100%;
padding: 20px 0;
display: flex;
justify-content: space-between;
align-items: center;
gap: 15px;
flex-wrap: wrap;
.left {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    strong { font-weight: 700; }
}
.back {
    display: flex;
    align-items: center;
    gap: 4px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: ${props => props.theme.blue};
    font-size: 14px;
    font-weight: 600;
    padding: 0;
    width: fit-content;
}
.buttons { display: flex; gap: 15px; }
button.tour {
    border-radius: 0.9em;
    padding: 10px 20px 10px 12px;
    transition: all ease-in-out 0.2s;
    font-size: 14px;
    cursor: pointer;
    border: 2px solid ${props => props.theme.lightGreen};
    background-color: ${props => props.theme.lightGreen};
    span {
        display: flex;
        justify-content: center;
        align-items: center;
        color: ${props => props.theme.white};
        font-weight: 600;
    }
    &:active { transform: scale(0.9); }
}
`
